import { render, staticRenderFns } from "./AdvantageItems.vue?vue&type=template&id=736b07e9&scoped=true&"
import script from "./AdvantageItems.vue?vue&type=script&lang=js&"
export * from "./AdvantageItems.vue?vue&type=script&lang=js&"
import style0 from "./AdvantageItems.vue?vue&type=style&index=0&id=736b07e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736b07e9",
  null
  
)

component.options.__file = "AdvantageItems.vue"
export default component.exports